import { create } from 'zustand';

type ModalButton = {
  label: string;
  onClick?: () => void;
  type: 'button' | 'submit';
  form?: string;
  variant?:
    | 'primary'
    | 'outline'
    | 'danger'
    | 'success'
    | 'warning'
    | 'icon'
    | 'link'
    | 'accordion'
    | 'createDrillDown'
    | 'closeDrillDown';
  showLoading?: boolean;
  disabled?: boolean;
  autoFocus?: boolean;
};
interface ModalData {
  id: string;
  title: string;
  content: React.ReactNode;
  buttons?: ModalButton[];
  size: 'sm' | 'md' | 'lg' | 'xl' | '2xl';
}

interface ModalState {
  isOpen: boolean;
  loading: boolean;
  modalData: ModalData;
  openModal: (data: ModalData) => void;
  closeModal: () => void;
  setLoading: (loading: boolean) => void;
}

const emptyModalData: ModalData = {
  id: '',
  content: '',
  buttons: [],
  title: '',
  size: 'md',
};

export const useModalStore = create<ModalState>((set) => ({
  isOpen: false,
  loading: false,
  modalData: emptyModalData,
  openModal: (data) => set({ isOpen: true, modalData: data }),
  closeModal: () => set({ isOpen: false, modalData: emptyModalData }),
  setLoading: (loading) => set({ loading }),
}));
